import { useMutation } from '@hooks/reactQuery';

import { checkAssetSubTypeName } from '@api/assetTypes';

import { handleErrorFromMessage } from '@utils/handleRequestError';

import { IResponseError } from '@interfaces/errors/apiErrors';

import { EErrorCodes } from '@enums/errorCodes';

import { CHECK_ASSET_SUBTYPE_NAME } from '@constants/queryKeys';

export const useMutateCheckAssetSubTypeName = () => {
	const {
		mutateAsync: handleCheckAssetSubTypeName,
		isLoading: isLoadingCheckAssetSubTypeName,
	} = useMutation<string>({
		mutationKey: [CHECK_ASSET_SUBTYPE_NAME],
		mutationFn: checkAssetSubTypeName,
		onError: (err: IResponseError) => {
			if (!err.errors.find((item) => item.code === EErrorCodes.assetSubTypeNameMustBeUnique)) {
				handleErrorFromMessage(err);
			}
		},
	});

	return {
		handleCheckAssetSubTypeName,
		isLoadingCheckAssetSubTypeName,
	};
};
